import { Divider, notification, Typography, Spin } from 'antd'
import Axios from 'axios'
import { SubmissionErrors } from 'final-form'
import React, { Fragment, useCallback, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { IPostRequestError } from '../../common/models'
import { dashboardRoutes } from '../../setup/config'
import { titles } from '../../setup/messages'
import GiftForm from './GiftForm'
import { IGift } from './models'

const EditGiftPage: React.FC = () => {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [gift, setGift] = useState<IGift>()
  const endpoint = `/api/gifts/${id}`

  const onFormSubmit = useCallback(async (newGift: IGift) => {
    const { name, cost, description, amount, files } = newGift
    setLoading(true)
    
    try {
      // Nếu có file ảnh mới, sử dụng FormData
      if (files && files[0]) {
        const data = new FormData()
        data.set('cost', cost.toString())
        if (description) {
          data.set('description', description)
        }
        data.set('name', name)
        if (amount !== undefined) {
          data.set('amount', amount.toString())
        }
        data.append('file', files[0])

        await Axios.patch(endpoint, data, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
      } else {
        // Nếu không có file mới, chỉ gửi text data
        await Axios.patch<IGift>(endpoint, {
          amount,
          cost,
          description: description || undefined,
          name
        })
      }

      setLoading(false)
      navigate(dashboardRoutes.giftsManagementPage)
      notification.success({
        message: 'Gift has been edited'
      })
    } catch (err:any) {
      setLoading(false)

      const errors: IPostRequestError[] = err.response.data
      if (Array.isArray(errors)) {
        return errors.reduce(
          (obj: SubmissionErrors, item: IPostRequestError) => {
            if (item.param && item.msg && obj) {
              obj[item.param] = item.msg
            }
            return obj
          }, {})
      }
    }
  }, [navigate, endpoint])

  const onCancel = useCallback(() => {
    navigate(dashboardRoutes.giftsManagementPage)
  }, [navigate])

  const fetchGift = useCallback(async () => {
    try {
      setLoading(true)
      const fetchedGift = await Axios.get<IGift>(endpoint)
      setGift(fetchedGift.data)
      setLoading(false)
    } catch (error) {
      setLoading(false)
      navigate(dashboardRoutes.giftsManagementPage)
      notification.error({
        message: 'Something went wrong',
      })
    }
  }, [endpoint, navigate])

  useEffect(() => {
    fetchGift()
  }, [fetchGift])

  return (
    <Fragment>
              <Typography.Title level={2}>{`${titles.editGift} ${gift ? gift.name : ''}`}</Typography.Title>
      <Divider />
      <Spin spinning={loading && !gift}>
        <GiftForm
          loading={loading && gift != null}
          onCancel={onCancel}
          onSubmit={onFormSubmit}
          initialValues={gift}
        />
      </Spin>
    </Fragment>
  )
}

export default EditGiftPage
